import { render, staticRenderFns } from "./level-skill.vue?vue&type=template&id=28995b0c&scoped=true&"
import script from "./level-skill.vue?vue&type=script&lang=js&"
export * from "./level-skill.vue?vue&type=script&lang=js&"
import style0 from "./level-skill.vue?vue&type=style&index=0&id=28995b0c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28995b0c",
  null
  
)

export default component.exports